import React, { Component } from "react";
import AccountMenu from "../components/header/AccountMenu";
import { withRouter } from "react-router-dom";
import { languages } from "../constants/languages";
import { GET_CHECKOUT_AUTH_URL_ENDPOINT } from "../util/OpenUpgradeCheckout";

class AccountMenuContainer extends Component {
  state = {
    anchorEl: null,
    fetchingBillingURL: false,
    billingURL: null,
  };

  handleMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.fetchBillingURL();
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSignOut = () => {
    window.firebase.auth().signOut();
  };

  handleProfileClick = () => {
    this.props.history.push("/account");
  };

  fetchBillingURL = async () => {
    if (this.state.fetchingBillingURL) {
      return;
    }
    // Reuse a previously fetched URL while it's still fresh, so reopening
    // the menu doesn't refetch every time
    if (
      this.state.billingURL &&
      Date.now() - this.billingURLFetchedAt < 10 * 60 * 1000
    ) {
      return;
    }
    this.setState({ fetchingBillingURL: true, billingURL: null });
    // Get the billing url
    try {
      const token = await window.firebase.auth().currentUser?.getIdToken();
      const response = await fetch(
        GET_CHECKOUT_AUTH_URL_ENDPOINT,
        {
          method: "POST",
          body: JSON.stringify({
            data: {
              locale: languages.getLanguage(),
              product: "worldclass",
              redirect_url: "/"
            }
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const json = await response.json();
      this.billingURLFetchedAt = Date.now();
      this.setState({ billingURL: json.result?.url || null });
    } catch (error) {
      console.error("Error fetching billing URL:", error);
    }
    this.setState({ fetchingBillingURL: false });
  };

  handleBillingClick = () => {
    if (!this.state.billingURL) {
      return;
    }
    // The URL is prefetched when the menu opens so we can navigate
    // synchronously here; Safari blocks window.open after an await as a popup
    window.open(this.state.billingURL, "_blank");
    this.handleClose();
  };

  handlePsdAdminClick = () => {
    this.props.history.push("/psdadmin");
  };

  handleSportaAdminClick = () => {
    this.props.history.push("/sportaadmin");
  };

  handleRVClick = () => {
    this.props.history.push("/belgiumrugby");
  };

  handleArenalAdminClick = () => {
    this.props.history.push("/arenaladmin");
  };

  generateProps = () => ({
    ...this.state,
    ...this.props,
    open: Boolean(this.state.anchorEl),
    handleMenu: this.handleMenu,
    handleClose: this.handleClose,
    handleSignOut: this.handleSignOut,
    handleProfileClick: this.handleProfileClick,
    handleBillingClick: this.handleBillingClick,
    handlePsdAdminClick: this.handlePsdAdminClick,
    handleSportaAdminClick: this.handleSportaAdminClick,
    handleRVClick: this.handleRVClick,
    handleArenalAdminClick: this.handleArenalAdminClick,
  });

  render() {
    return <AccountMenu {...this.generateProps()} />;
  }
}

export default withRouter(AccountMenuContainer);
